import PaperflyAPI from '../../server/api/PaperflyAPI';
import { receiveBadRequest } from './rootAction';

export const RECEIVE_SIGNME_REGISTRATION_STATUS =
  'RECEIVE_SIGNME_REGISTRATION_STATUS';
export const RESET_SIGNME_REGISTRATION_STATUS =
  'RESET_SIGNME_REGISTRATION_STATUS';
export const RECEIVE_ESIGNATURE_DATA = 'RECEIVE_ESIGNATURE_DATA';
export const SET_SIGNME_IDENTITY_ID = 'SET_SIGNME_IDENTITY_ID';
export const RESET_DOCUMENT_ESIGNATURE_STATUS =
  'RESET_DOCUMENT_ESIGNATURE_STATUS';
export const REQUEST_DOCUMENT_ESIGNATURE = 'REQUEST_DOCUMENT_ESIGNATURE';
export const RECEIVE_FINALISED_PDF_DATA = 'RECEIVE_FINALISED_PDF_DATA';
export const REQUEST_FINALISE_PDF_DOC = 'REQUEST_FINALISE_PDF_DOC';
export const SET_ERROR_ON_FINALISE_PDF_DOC = 'SET_ERROR_ON_FINALISE_PDF_DOC';
export const SET_ATRUST_SHORT_TERM = 'SET_ATRUST_SHORT_TERM';
export const CLEAR_ATRUST_SHORT_TERM = 'CLEAR_ATRUST_SHORT_TERM';

export function receiveSignmeRegistrationStatus(status) {
  return {
    type: RECEIVE_SIGNME_REGISTRATION_STATUS,
    payload: status
  };
}

export function resetSignmeRegistrationStatus() {
  return {
    type: RESET_SIGNME_REGISTRATION_STATUS
  };
}

export function resetDocumentESignatureStatus(docId) {
  return {
    type: RESET_DOCUMENT_ESIGNATURE_STATUS,
    payload: docId
  };
}

export function requestDocumentESignature(docId, internalCallbackId) {
  return {
    type: REQUEST_DOCUMENT_ESIGNATURE,
    payload: {
      docId,
      internalCallbackId
    }
  };
}

export function receiveESignatureData(data) {
  return {
    type: RECEIVE_ESIGNATURE_DATA,
    payload: data
  };
}

export function setSignmeIdentityId(signmeIdentityId) {
  return {
    type: SET_SIGNME_IDENTITY_ID,
    payload: signmeIdentityId
  };
}

/** Short-term (activationWorkflow "2") session after WebID — survives QES popup close. */
export function setAtrustShortTerm({
  recipientRequestId,
  activationWorkflow,
  deadlineAt
}) {
  return {
    type: SET_ATRUST_SHORT_TERM,
    payload: { recipientRequestId, activationWorkflow, deadlineAt }
  };
}

export function clearAtrustShortTerm() {
  return {
    type: CLEAR_ATRUST_SHORT_TERM
  };
}

function requestFinalisePdfDoc(err) {
  return {
    type: REQUEST_FINALISE_PDF_DOC,
    payload: err
  };
}

function errorOnFinalisePdfDoc(err) {
  return {
    type: SET_ERROR_ON_FINALISE_PDF_DOC,
    payload: err
  };
}

export function finalisePdfDoc(id, recipientRequestId, recipientIds, formData) {
  return dispatch => {
    dispatch(requestFinalisePdfDoc);
    const jsonData = {};
    Array.from(formData).forEach(([key, value]) => (jsonData[key] = value));

    return PaperflyAPI.finalisePdfDoc(
      id,
      recipientRequestId,
      recipientIds,
      jsonData
    ).then(
      response => {
        if (response.errorCode) {
          dispatch(receiveBadRequest(response.errorCode));
          dispatch(errorOnFinalisePdfDoc(response.errorCode));

          return;
        }

        dispatch({
          type: RECEIVE_FINALISED_PDF_DATA,
          payload: {
            id,
            pages: response.documents[id]
          }
        });
      },
      error => {
        dispatch(receiveBadRequest(error));
        dispatch(errorOnFinalisePdfDoc(error));
      }
    );
  };
}
